import { useParams } from 'react-router-dom';
import { config } from "../../data/config";
import { useEffect, useState } from 'react';
import { getCookies } from "cookies-next";
import { useCookies } from 'react-cookie';
import axios from "axios";
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import BreadCrump from '../tools/breadcrump';
import HeaderOfPage from '../tools/headerOfPage';
import ImageUploader from '../tools/uploaderImage';
import TissEditor from '../Editor/TissEditor';
import QACreator from '../Qa/QaComponent';
import { Tabs, Input, Button } from 'rsuite';
import changeUrl from "../../hoc/changeur";
import AutoTranslateButton from '../tools/AutoTranslateButton';

type LanguageCode = 'ku' | 'fa' | 'en' | 'ar' | 'tr';

interface MultilingualField {
    ku: string;
    fa: string;
    en: string;
    ar: string;
    tr: string;
    [key: string]: string;
}

// Helper function to get display name from multilingual or string
const getDisplayName = (name: any): string => {
    if (!name) return '';
    if (typeof name === 'string') return name;
    if (typeof name === 'object') {
        return name.en || name.fa || name.ku || name.ar || name.tr || '';
    }
    return String(name);
};

export default function EditPost() {
    const { t } = useTranslation();
    const { Id } = useParams();
    const [cookies] = useCookies(['token']);
    const cookie = getCookies();

    const [data, setData] = useState<any>(null);
    const [list, setListArticle] = useState<any>(null);
    const [error, setError] = useState<any>(null);
    const [key, setKey] = useState<number>(1);
    const [loading, setLoading] = useState<boolean>(true);
    const [saving, setSaving] = useState<boolean>(false);
    const [activeLang, setActiveLang] = useState<LanguageCode>('en');
    const languages = [
        { code: 'ku' as LanguageCode, label: 'Kurdish' },
        { code: 'fa' as LanguageCode, label: 'فارسی' },
        { code: 'en' as LanguageCode, label: 'English' },
        { code: 'ar' as LanguageCode, label: 'العربية' },
        { code: 'tr' as LanguageCode, label: 'Türkçe' }
    ];

    const inputStyle = "py-3 px-5 block w-full border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:pointer-events-none bg-white text-gray-900";

    const breadcrump = [
        { name: 'Dashboard', url: '/dashboard' },
        { name: 'Blog', url: '/dashboard/Blog' },
        { name: 'List Article', url: '/dashboard/Blog/Articles' },
        { name: 'Edit Post', url: null },
    ];

    const loadData = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${config.url}/v1/dashboard/post/${Id}`, {
                headers: { Authorization: 'Bearer ' + cookie['token'] }
            });
            const loadedData = res.data.message;
            // Ensure multilingual structure exists
            if (loadedData) {
                if (typeof loadedData.name === 'string') {
                    loadedData.name = { ku: loadedData.name, fa: loadedData.name, en: loadedData.name, ar: loadedData.name, tr: loadedData.name };
                } else if (loadedData.name && loadedData.name.nl) {
                    loadedData.name.ku = loadedData.name.nl;
                    delete loadedData.name.nl;
                    if (!loadedData.name.tr) loadedData.name.tr = '';
                }
                if (typeof loadedData.url === 'string' || !loadedData.url) {
                    loadedData.url = loadedData.url ? { ku: loadedData.url, fa: loadedData.url, en: loadedData.url, ar: loadedData.url, tr: loadedData.url } : { ku: '', fa: '', en: '', ar: '', tr: '' };
                } else if (loadedData.url && loadedData.url.nl) {
                    loadedData.url.ku = loadedData.url.nl;
                    delete loadedData.url.nl;
                    if (!loadedData.url.tr) loadedData.url.tr = '';
                }
                if (typeof loadedData.title === 'string' || !loadedData.title) {
                    loadedData.title = loadedData.title ? { ku: loadedData.title, fa: loadedData.title, en: loadedData.title, ar: loadedData.title, tr: loadedData.title } : { ku: '', fa: '', en: '', ar: '', tr: '' };
                } else if (loadedData.title && loadedData.title.nl) {
                    loadedData.title.ku = loadedData.title.nl;
                    delete loadedData.title.nl;
                    if (!loadedData.title.tr) loadedData.title.tr = '';
                }
                if (typeof loadedData.description === 'string' || !loadedData.description) {
                    loadedData.description = loadedData.description ? { ku: loadedData.description, fa: loadedData.description, en: loadedData.description, ar: loadedData.description, tr: loadedData.description } : { ku: '', fa: '', en: '', ar: '', tr: '' };
                } else if (loadedData.description && loadedData.description.nl) {
                    loadedData.description.ku = loadedData.description.nl;
                    delete loadedData.description.nl;
                    if (!loadedData.description.tr) loadedData.description.tr = '';
                }
                if (typeof loadedData.keywords === 'string' || !loadedData.keywords) {
                    loadedData.keywords = loadedData.keywords ? { ku: loadedData.keywords, fa: loadedData.keywords, en: loadedData.keywords, ar: loadedData.keywords, tr: loadedData.keywords } : { ku: '', fa: '', en: '', ar: '', tr: '' };
                } else if (loadedData.keywords && loadedData.keywords.nl) {
                    loadedData.keywords.ku = loadedData.keywords.nl;
                    delete loadedData.keywords.nl;
                    if (!loadedData.keywords.tr) loadedData.keywords.tr = '';
                }
            }
            setData(loadedData);
        } catch (err: any) {
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: err.response?.data?.message || t('Error loading post'),
            });
        } finally {
            setLoading(false);
        }
    };

    const loadGroups = async () => {
        try {
            const res = await axios.get(`${config.url}/v1/dashboard/bloggroup`, {
                headers: { Authorization: 'Bearer ' + cookie['token'] }
            });
            setListArticle(res.data.message);
        } catch (err) {
            console.error('Error loading groups:', err);
        }
    };

    const save = async () => {
        setSaving(true);
        setError(null);
        try {
            await axios.put(`${config.url}/v1/dashboard/post/${Id}`, data, {
                headers: { Authorization: 'Bearer ' + cookie['token'] }
            });
            Swal.fire({
                icon: 'success',
                title: t('Success'),
                text: t('Post updated successfully'),
                timer: 1500,
                showConfirmButton: false
            });
            setKey(prev => prev + 1);
        } catch (err: any) {
            setError(err.response?.data?.message?.errors || null);
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: err.response?.data?.message || t('Error updating post'),
            });
        } finally {
            setSaving(false);
        }
    };

    useEffect(() => {
        loadGroups();
        loadData();
    }, []);

    if (loading) {
        return (
            <div className="bg-gray-50 min-h-screen p-4 md:p-6">
                <BreadCrump data={breadcrump} />
                <HeaderOfPage name="Edit Post" />
                <div className="bg-white rounded-xl shadow-sm p-12 mt-6">
                    <div className="flex flex-col items-center justify-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
                        <p className="text-gray-600 font-medium">در حال بارگذاری...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (!data) {
        return (
            <div className="bg-gray-50 min-h-screen p-4 md:p-6">
                <BreadCrump data={breadcrump} />
                <HeaderOfPage name="Edit Post" />
                <div className="bg-white rounded-xl shadow-sm p-12 mt-6">
                    <p className="text-center text-gray-500">پستی یافت نشد</p>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-gray-50 min-h-screen p-4 md:p-6">
            <BreadCrump data={breadcrump} />
            <HeaderOfPage name="Edit Post" />

            <div className="mt-6">
                <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                    <Tabs defaultActiveKey="1" appearance="pills">
                        {/* Content Tab */}
                        <Tabs.Tab eventKey="1" title={t('متن')}>
                            <div className="p-6">
                                <TissEditor component="post" parent={data.id} />
                            </div>
                        </Tabs.Tab>

                        {/* Settings Tab */}
                        <Tabs.Tab eventKey="2" title={t('تنظیمات')}>
                            <div className="p-6" dir="rtl">
                                <div className="space-y-6">
                                    {/* Language Selector */}
                                    <div className="mb-4">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            زبان
                                        </label>
                                        <div className="flex gap-2">
                                            {languages.map((lang) => (
                                                <button
                                                    key={lang.code}
                                                    type="button"
                                                    onClick={() => setActiveLang(lang.code)}
                                                    className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${activeLang === lang.code
                                                        ? 'bg-blue-600 text-white'
                                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                                        }`}
                                                >
                                                    {lang.label}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Basic Information */}
                                    <div>
                                        <h3 className="text-lg font-semibold text-gray-800 mb-4">اطلاعات پایه</h3>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    Code <span className="text-red-500">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    value={data.code || ''}
                                                    className={`${inputStyle} ${error?.code ? 'border-red-500 bg-red-50' : ''}`}
                                                    onChange={e => setData({ ...data, code: e.target.value })}
                                                    placeholder="مثال: POST001"
                                                />
                                                {error?.code && <p className="mt-1 text-sm text-red-600">{error.code.message}</p>}
                                            </div>

                                            <div>
                                                <div className="flex items-center justify-between mb-2">
                                                    <label className="block text-sm font-medium text-gray-700">
                                                        {t('Name')} ({languages.find(l => l.code === activeLang)?.label}) <span className="text-red-500">*</span>
                                                    </label>
                                                    <AutoTranslateButton
                                                        sourceText={data.name?.en || ''}
                                                        targetLang={activeLang}
                                                        onTranslated={(text) => {
                                                            const slugValue = String(changeUrl(text));
                                                            setData({ ...data, name: { ...data.name, [activeLang]: text }, url: { ...data.url, [activeLang]: slugValue } });
                                                        }}
                                                    />
                                                </div>
                                                <input
                                                    type="text"
                                                    value={data.name?.[activeLang] || ''}
                                                    className={`${inputStyle} ${error?.name ? 'border-red-500 bg-red-50' : ''}`}
                                                    onChange={e => {
                                                        const nameValue = e.target.value;
                                                        const slugValue = String(changeUrl(nameValue));
                                                        setData({
                                                            ...data,
                                                            name: {
                                                                ...data.name,
                                                                [activeLang]: nameValue
                                                            },
                                                            url: {
                                                                ...data.url,
                                                                [activeLang]: slugValue
                                                            }
                                                        });
                                                    }}
                                                    placeholder="عنوان پست"
                                                />
                                                {error?.name && <p className="mt-1 text-sm text-red-600">{error.name.message}</p>}
                                            </div>

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    URL ({languages.find(l => l.code === activeLang)?.label}) <span className="text-red-500">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    value={data.url?.[activeLang] || ''}
                                                    className={`${inputStyle} ${error?.url ? 'border-red-500 bg-red-50' : ''}`}
                                                    onChange={e => setData({
                                                        ...data,
                                                        url: {
                                                            ...data.url,
                                                            [activeLang]: e.target.value
                                                        }
                                                    })}
                                                    placeholder="slug"
                                                />
                                                {error?.url && <p className="mt-1 text-sm text-red-600">{error.url.message}</p>}
                                            </div>

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    {t('Group')}
                                                </label>
                                                <select
                                                    value={data.parent || ''}
                                                    onChange={e => setData({ ...data, parent: e.target.value })}
                                                    className={inputStyle}
                                                >
                                                    <option value="">{t('Choice Group')}...</option>
                                                    {list?.map((item: any) => (
                                                        <option key={item.id} value={item.id}>{getDisplayName(item.name)}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    {t('نوع پخش')}
                                                </label>
                                                <select
                                                    value={data.listmode || 0}
                                                    onChange={e => setData({ ...data, listmode: e.target.value })}
                                                    className={inputStyle}
                                                >
                                                    <option value={0}>{t('مدل 1')}</option>
                                                    <option value={1}>{t('مدل 2')}</option>
                                                    <option value={2}>{t('مدل 3')}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Save Button */}
                                    <div className="flex justify-end pt-4 border-t border-gray-200">
                                        <Button
                                            appearance="primary"
                                            onClick={save}
                                            disabled={saving}
                                            className="px-8"
                                        >
                                            {saving ? (
                                                <>
                                                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white inline-block ml-2"></div>
                                                    در حال ذخیره...
                                                </>
                                            ) : (
                                                <>
                                                    <svg className="w-4 h-4 inline-block ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                                    </svg>
                                                    {t('Update Post')}
                                                </>
                                            )}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Tabs.Tab>

                        {/* SEO Tab */}
                        <Tabs.Tab eventKey="3" title={t('سئو')}>
                            <div className="p-6" dir="rtl">
                                <div className="space-y-4">
                                    {/* Language Selector */}
                                    <div className="mb-4">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            زبان
                                        </label>
                                        <div className="flex gap-2">
                                            {languages.map((lang) => (
                                                <button
                                                    key={lang.code}
                                                    type="button"
                                                    onClick={() => setActiveLang(lang.code)}
                                                    className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${activeLang === lang.code
                                                        ? 'bg-blue-600 text-white'
                                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                                        }`}
                                                >
                                                    {lang.label}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                    <div>
                                        <div className="flex items-center justify-between mb-2">
                                            <label className="block text-sm font-medium text-gray-700">
                                                تیتر ({languages.find(l => l.code === activeLang)?.label})
                                            </label>
                                            <AutoTranslateButton
                                                sourceText={data.title?.en || ''}
                                                targetLang={activeLang}
                                                onTranslated={(text) => setData({ ...data, title: { ...data.title, [activeLang]: text } })}
                                            />
                                        </div>
                                        <Input
                                            value={data.title?.[activeLang] || ''}
                                            className={inputStyle}
                                            onChange={(e) => setData({
                                                ...data,
                                                title: {
                                                    ...data.title,
                                                    [activeLang]: e
                                                }
                                            })}
                                            placeholder="تیتر صفحه"
                                        />
                                    </div>

                                    <div>
                                        <div className="flex items-center justify-between mb-2">
                                            <label className="block text-sm font-medium text-gray-700">
                                                {t('Keywords')} ({languages.find(l => l.code === activeLang)?.label})
                                            </label>
                                            <AutoTranslateButton
                                                sourceText={data.keywords?.en || ''}
                                                targetLang={activeLang}
                                                onTranslated={(text) => setData({ ...data, keywords: { ...data.keywords, [activeLang]: text } })}
                                            />
                                        </div>
                                        <Input
                                            as={'textarea'}
                                            rows={3}
                                            value={data.keywords?.[activeLang] || ''}
                                            className={inputStyle}
                                            onChange={(e) => setData({
                                                ...data,
                                                keywords: {
                                                    ...data.keywords,
                                                    [activeLang]: e
                                                }
                                            })}
                                            placeholder="کلمات کلیدی (با کاما جدا کنید)"
                                        />
                                    </div>

                                    <div>
                                        <div className="flex items-center justify-between mb-2">
                                            <label className="block text-sm font-medium text-gray-700">
                                                {t('Description')} ({languages.find(l => l.code === activeLang)?.label})
                                            </label>
                                            <AutoTranslateButton
                                                sourceText={data.description?.en || ''}
                                                targetLang={activeLang}
                                                onTranslated={(text) => setData({ ...data, description: { ...data.description, [activeLang]: text } })}
                                            />
                                        </div>
                                        <Input
                                            as={`textarea`}
                                            rows={4}
                                            value={data.description?.[activeLang] || ''}
                                            className={inputStyle}
                                            onChange={(e) => setData({
                                                ...data,
                                                description: {
                                                    ...data.description,
                                                    [activeLang]: e
                                                }
                                            })}
                                            placeholder="توضیحات متا"
                                        />
                                    </div>

                                    <div className="flex justify-end pt-4 border-t border-gray-200">
                                        <Button
                                            appearance="primary"
                                            onClick={save}
                                            disabled={saving}
                                            className="px-8"
                                        >
                                            {saving ? 'در حال ذخیره...' : 'ذخیره سازی'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Tabs.Tab>

                        {/* Images Tab */}
                        <Tabs.Tab eventKey="4" title={t('تصاویر')}>
                            <div className="p-6" dir="rtl">
                                <div className="space-y-6">
                                    <div>
                                        <h3 className="text-lg font-semibold text-gray-800 mb-4">تصاویر پست</h3>
                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                                <label className="block text-sm font-medium text-gray-700 mb-3">
                                                    {t('Thumbnail')}
                                                </label>
                                                <div className="border-2 border-dashed border-gray-300 rounded-lg p-4">
                                                    <ImageUploader id={data.id} component="Gallery" />
                                                </div>
                                            </div>

                                            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                                <label className="block text-sm font-medium text-gray-700 mb-3">
                                                    {t('دارک مد')}
                                                </label>
                                                <div className="border-2 border-dashed border-gray-300 rounded-lg p-4">
                                                    <ImageUploader id={data.id} component="Postdark" />
                                                </div>
                                            </div>

                                            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                                <label className="block text-sm font-medium text-gray-700 mb-3">
                                                    {t('هدر صفحه')}
                                                </label>
                                                <div className="border-2 border-dashed border-gray-300 rounded-lg p-4">
                                                    <ImageUploader id={data.id} component="PostHeader" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Tabs.Tab>

                        {/* QA Tab */}
                        <Tabs.Tab eventKey="5" title={t('پرسش پاسخ')}>
                            <div className="p-6">
                                <QACreator parent={data.id} />
                            </div>
                        </Tabs.Tab>
                    </Tabs>
                </div>
            </div>
        </div>
    );
}
